export enum RoomingListEditStep {
    INFO,
    FILE_HISTORY
}